<!-- 
<img src="../../../assets/images/translucentOhaLogo.png" class="bg hideOnMobile" alt="Oregon Health Authority Logo" aria-label="Oregon Health Authority Logo">

<img src="../../../assets/images/translucentOhaLogo.png" class="bg-mobile showOnMobile" alt="Oregon Health Authority Logo" aria-label="Oregon Health Authority Logo">
 -->
<div *ngIf="!loggingIn" class="flex flex-col sm:justify-start sm:items-center gap-4">
  <!-- B2C Login options -->
  <div class="flex flex-col md:flex-row gap-6 sm:gap-40" *ngIf="isB2C()">

    <div class="flex flex-col gap-2 justify-start items-center">
      <span style="font-size: x-large;"> <strong>WEMS Login</strong> </span>
      <!-- <span style="font-size: x-large;"> <strong>Login / Register New Account</strong> </span> -->
      <button mat-raised-button (click)="login()" color="primary">Login</button>
    </div>
<!-- 
    <div class="flex flex-col gap-2 justify-start items-center">
      <span style="font-size: x-large;"> <strong>New User?</strong> </span>
      <button mat-raised-button color="primary" (click)="login()">Let's Get Started!</button>
    </div>
 -->
  </div>
  <!-- AAD Login options -->
  <!-- 
  <div class="flex flex-col md:flex-row gap-6 sm:gap-40" *ngIf="isAAD()">
    <div class="flex flex-col justify-center items-center gap-8 p-t-32">
      <div class="flex flex-col md:flex-row max-md:justify-center max-md:items-center gap-2">
       <span style="font-family: Oswald; font-size: 30pt;">Administration Portal</span>
      </div>
     <button mat-button (click)="login()" color="primary">
       <span class="f-s-20 p-32">Enter</span>
     </button>
  </div> 
  -->

</div>

<div *ngIf="loggingIn">
  <div id="globalLoader" class="global-loader">
    <h1>Loading...</h1>
  </div>
</div>
